import { Injectable, signal } from '@angular/core';

/**
 * Lot I (client clinique — item 21) : état UI responsive partagé.
 * Version minimale sans dépendance : gère l'ouverture/fermeture de la sidebar
 * mobile (< 1024px) entre le header (bouton hamburger) et le layout.
 * Code conservé si besoin : rien n'est supprimé du layout desktop existant.
 */
@Injectable({ providedIn: 'root' })
export class LayoutResponsiveService {
  /** Sidebar mobile ouverte (drawer superposé + backdrop). */
  readonly sidebarOpen = signal(false);

  /** Ferme le drawer (clic backdrop, navigation, burger→croix). */
  close(): void {
    this.sidebarOpen.set(false);
  }

  /** Bascule l'état d'ouverture du drawer. */
  toggle(): void {
    this.sidebarOpen.update(v => !v);
  }
}
